export function clearStoredMfaMetadata() {
  localStorage.removeItem('activateMfaLater');
  localStorage.removeItem('notice_mfa_verification_required');
  localStorage.removeItem('mfa_verification_required');
  localStorage.removeItem('mfa_activated_at');
  localStorage.removeItem('last_mfa_notice_at');
  localStorage.removeItem('last_mfa_verification_at');
  localStorage.removeItem('scheduled_activation_date_mfa');
}
  